import { nanoid } from 'nanoid';

import { getTaskProcessTypeOptionsFilter } from '@/constants/options/task-process-type.option';
import { getTaskOptionsFilter } from '@/constants/options/task.option';
import { RoleEnum } from '@/types/enums/role.enum';
import type { KeyWithFilter } from '@/utils/filter/filter';
import { t } from '@/utils/lang';

export const filters: () => KeyWithFilter[] = () => {
    return [
        {
            key: [
                { key: 'name', trans: 'name', defaultOperator: 'like' },
                { key: 'code', trans: 'code.task', defaultOperator: 'like' },
                {
                    key: 'ticket.code',
                    trans: 'code.ticket',
                    defaultOperator: 'like',
                },
            ],
            type: 'input',
            value: [],
        },
        {
            key: [
                {
                    key: 'scheduledTime',
                    trans: 'scheduledTime',
                    defaultOperator: '=',
                },
            ],
            type: 'date',
            value: [],
        },
        {
            key: [
                {
                    key: 'deviceId',
                    trans: 'device',
                    keyService: 'Devices',
                    defaultOperator: '=',
                },
                {
                    key: 'ticket.customerId',
                    trans: 'Customers',
                    keyService: 'Customers',
                    defaultOperator: '=',
                    excludeRoles: [RoleEnum.CUSTOMER],
                },
                {
                    key: 'assigneeId',
                    trans: 'Assignees.taskRepeat',
                    keyService: 'Assignees',
                    defaultOperator: '=',
                    excludeRoles: [RoleEnum.KTV],
                },
                {
                    key: 'taskCheckTypeId',
                    trans: 'TaskTypes',
                    keyService: 'TaskTypes',
                    defaultOperator: '=',
                },
            ],
            type: 'orm',
            value: [],
        },
        {
            key: [
                {
                    key: 'taskCheckStatus',
                    trans: 'taskCheckStatus',
                    defaultOperator: '=',
                },
            ],
            type: 'select',
            value: getTaskOptionsFilter(),
        },
        {
            key: [
                {
                    key: 'taskProcessType',
                    trans: 'taskProcessType',
                    defaultOperator: '=',
                },
            ],
            type: 'select',
            value: getTaskProcessTypeOptionsFilter(true),
        },
        {
            key: [
                {
                    key: 'isLateTaskCheck',
                    trans: 'isLateTaskCheck',
                    defaultOperator: '=',
                    multipleSelect: false,
                },
            ],
            type: 'select',
            value: [
                {
                    id: nanoid(),
                    value: true,
                    title: t('Trễ hạn'),
                    label: t('Trễ hạn'),
                },
                {
                    id: nanoid(),

                    value: false,
                    title: t('Đúng hạn'),
                    label: t('Đúng hạn'),
                },
            ],
        },
    ];
};
